import { parseOtherELF, parseOtherRA, needOtherELF, needOtherRA, } from '../store/modules/record/helpers/parsing'

const labelCreator = {
  'countries': ({ code, name, }) => `${name} (${code})`,
  'regions': ({ code, }) => `${code}`,
  'jurisdictions': ({ code, }) => `${code}`,
  'gleif-accepted-jurisdictions': ({ code, }) => `${code}`,
  'registration-authorities': ({ internationalName, localName, code, internationalOrganizationName, id, other, jurisdictions, }) => {
    let optionalCountryCodes = jurisdictions
      ? jurisdictions
        .map((j) => j.countryCode)
        .filter((cc) => !!cc)
        .map((cc) => `(${cc})`)
        .join()
      : ''
    return id && needOtherRA(id)
      ? toString(parseOtherRA({
        id,
        other,
      }))
      : `${internationalOrganizationName || internationalName || localName || ''} (${code}) ${optionalCountryCodes}`
  },
  'entity-legal-forms': ({ code, names, id, other, countryCode, }) => {
    let optionalCountryCode = countryCode ? `(${countryCode})` : ''
    return id && needOtherELF(id) ? toString(parseOtherELF({
      id,
      other,
    })) : `${names[0].localName} (${code}) ${optionalCountryCode}`
  },
  'lei-issuers': ({ lei, marketingName, }) => `${marketingName} (${lei})`,
}

const toString = (val) => Array.isArray(val) ? val.join('; ') : val

export const getLabelForResource = (resource, item) => resource && item ? labelCreator[resource](item) : ''

export const getValueForResource = (code, items) => code && items ? items.find((item) => item.code === code) : ''



// WEBPACK FOOTER //
// ./src/utils/resources.js